import { compose } from 'redux';

import RequireAuth from '../components/routing/RequireAuth';
import RequireValidAlbumFolder from '../components/routing/RequireValidAlbumFolder';
import { AUTH_TYPE } from '../constants/auth';
import SetAlbumFolder from '../components/routing/discover/SetAlbumFolder';
import withCustomGTMDimensions from '../components/routing/discover/withGTMCustomDimensions';
import JoinAlbumFolderMasterView from '../views/onboarding/join/JoinAlbumFolderMasterView';
import withHierarchyViewsCreate from '../components/global/HiearchyGroups/hoc/withHierarchyViewsCreate';
import JoinAlbumFolder from '../views/onboarding/join/components/JoinAlbumFolder';
import JoinAlbumFolderPhotoSearchCheckout from '../views/onboarding/join/components/JoinAlbumFolderPhotoSearchCheckout';

const routes = [
  {
    path: '/join/album-folder/:albumFolderId',
    exact: false,
    component: RequireAuth(
      compose(
        withCustomGTMDimensions,
        RequireValidAlbumFolder,
        SetAlbumFolder,
        withHierarchyViewsCreate(({ match }) => match.params.albumFolderId),
      )(JoinAlbumFolderMasterView),
      { authType: AUTH_TYPE.PHONE },
    ),
    routes: [
      {
        path: '/join/album-folder/:albumFolderId/photo-search-checkout',
        exact: true,
        // Imported from the new consumer 2.0 app as it is developed as a new
        // component of that flow.
        component: JoinAlbumFolderPhotoSearchCheckout,
      },
      {
        path: '/join/album-folder/:albumFolderId',
        exact: true,
        component: JoinAlbumFolder,
      },
    ],
  },
];

export default routes;
